import React from "react";
import "./PageStyles.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>

        <p>
          <strong>Effective Date: May 2026</strong>
        </p>

        <p>
          At Alpha APK Store™, accessible from https://www.alphaapkstore.com,
          one of our main priorities is the privacy of our visitors. This
          Privacy Policy explains what information we collect, how we use it,
          and how we protect user privacy.
        </p>

        <h2>Information We Collect</h2>

        <p>
          Alpha APK Store can be used without creating an account. Visitors can
          browse APK pages and download APK files without login.
        </p>

        <p>
          If you choose to sign in using Google login or email login, we may
          collect basic account information such as your email address, name,
          profile picture, and unique account ID. This information is used only
          to provide account-related features and improve user experience.
        </p>

        <p>
          We do not collect payment details, phone numbers, government IDs, or
          sensitive personal information.What data you collect (comments, analytics), cookies, third-party links
        </p>

        <h2>Google Login and Account Features</h2>

        <p>
          Alpha APK Store may offer optional Google sign-in and email login
          features using Supabase Authentication. Login is optional and is not
          required to download APK files.
        </p>

        <p>
          Account features may be used for future improvements such as saved
          apps, user preferences, favorites, reviews, comments, and personalized
          app suggestions.
        </p>

        <h2>Analytics and Website Data</h2>

        <p>
          Like many websites, we may collect standard visitor information such
          as IP address, browser type, device type, operating system, referring
          pages, visited pages, date and time, clicks, and general usage
          behavior.
        </p>

        <p>
          This information is used for analytics, website improvement, security,
          bug fixing, performance monitoring, and understanding which content is
          useful for visitors.
        </p>

        <h2>Cookies</h2>

        <p>
          Alpha APK Store may use cookies and similar technologies to improve
          user experience, remember preferences, understand visitor behavior,
          support analytics, and improve website performance.
        </p>

        <p>
          Cookies may also be used by third-party services such as Google
          Analytics, Google AdSense, and authentication services.
        </p>

        <p>
          You can choose to disable cookies through your browser settings.
          Some website features may not work properly if cookies are disabled.
        </p>

        <h2>Google AdSense</h2>

        <p>
          We may use Google AdSense to display advertisements on our website.
          Google and third-party vendors may use cookies to serve ads based on
          your visits to this website and other websites.
        </p>

        <p>
          Google uses advertising cookies to serve personalized or
          non-personalized ads. Users can manage or opt out of personalized
          advertising by visiting Google Ads Settings.
        </p>

        <h2>Third-Party Services</h2>

        <p>
          We may use third-party services such as Google Analytics, Google
          Search Console, Google AdSense, Google Login, and Supabase to improve
          our services, provide login features, analyze website performance, and
          protect the website.
        </p>

        <p>
          These third-party services may collect information according to their
          own privacy policies.
        </p>

        <h2>APK Downloads and External Links</h2>

        <p>
          Our website may contain links to APK download files or third-party
          websites. We are not responsible for the privacy policies, security
          practices, or content of external websites.
        </p>

        <p>
          Users should always check app permissions, Android compatibility, and
          device security before installing any APK file.
        </p>

        <h2>iPhone and iOS Notice</h2>

        <p>
          APK files are only supported on Android devices. iPhone, iPad, and iOS
          devices cannot install APK files. iOS users should use the Apple App
          Store for iPhone apps.
        </p>

        <h2>Children&apos;s Information</h2>

        <p>
          We do not knowingly collect personally identifiable information from
          children under the age of 13. If you believe a child has provided such
          information, please contact us and we will take appropriate action.
        </p>

        <h2>DMCA & Copyright</h2>

        <p>
          All trademarks, logos, application names, and brand names belong to
          their respective owners. Alpha APK Store does not claim ownership of
          third-party applications, logos, or trademarks displayed on this
          website.
        </p>

        <p>
          If you believe any content violates copyright laws, please contact us
          and we will review the content promptly.
        </p>

        <h2>Data Security</h2>

        <p>
          We take reasonable steps to protect website data and account-related
          information. However, no online platform can guarantee complete
          security.
        </p>

        <h2>Consent</h2>

        <p>
          By using Alpha APK Store, you consent to this Privacy Policy and agree
          to its terms.
        </p>

        <h2>Updates to This Policy</h2>

        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date.
        </p>

        <h2>Contact Us</h2>

        <p>
          If you have any questions about this Privacy Policy, contact us at:
        </p>

        <p>
          <strong>alphaapkstore@gmail.com</strong>
        </p>
      </div>
    </div>
  );
}